import Http from "./../../utils/Http";
import { authLogout, authUser } from "./../../store/reducers/auth";
import { notifyError } from "./../../utils/Helper";

const apiBase = "/api/v1/enterprise/";

/**
 * login user
 *
 * @param credentials
 * @returns {function(*)}
 */
export function login(credentials) {
  return Http.post("login", credentials);
}

export function verifyEmail(params) {
  return Http.post("verify-email", params);
}

/**
 * logout user
 *
 * @returns {function(*)}
 */
export function logout() {
  return (dispatch) => {
    dispatch(authLogout());
    // return Http.delete("auth/logout")
    //   .then(() => {
    //     dispatch(authLogout());
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
}

export function fetchUser() {
  return (dispatch) => {
    return Http.get(apiBase + "general/auth/me")
      .then((res) => {
        const data = res.data.response;
        dispatch(authUser(data));
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          const { data } = err.response;
          notifyError(data.message);
          dispatch(authLogout());
        }
      });
  };
}

export function updateProfile(params) {
  return Http.post(apiBase + "general/auth/updateprofile", params);
}

export function forgotPasswordEmail(params) {
  return Http.post("forgotpassword", params);
}

export function getMFADetails(params) {
  return Http.post(apiBase + "mfa/auth/get-details", params);
}

export function sendMFACode(params) {
  return Http.post(apiBase + "mfa/auth/send-code", params);
}

export function authCheckMFA(params) {
  return Http.post(apiBase + "mfa/auth/verify-code", params);
}

export function resetPassword(params) {
  return Http.post("resetpassword", params);
}

export function updateCompanyInfo(params) {
  return Http.post(apiBase + "general/auth/updatecompanyinfo", params);
}

export function changePassword(params) {
  return Http.post(apiBase + "general/auth/changepassword", params);
}

export function updateProfileImageRequest(params) {
  return Http.post(apiBase + "general/auth/updateprofileimage", params);
}

export function updateThemeSettings(params) {
  return Http.post(apiBase + "general/auth/updatethemesettings", params);
}

export function sendHelpMessage(params) {
  return Http.post(apiBase + "general/help-email", params);
}

export function demoVideoViewed() {
  return (dispatch) => {
    return Http.post(apiBase + "general/auth/demo-video-viewed")
      .then((res) => {
        const data = res.data.response;
        dispatch(authUser(data));
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          const { data } = err.response;
          notifyError(data.message);
          dispatch(authLogout());
        }
      });
  };
}

export function putSignedUrlS3(params) {
  return Http.post(
    apiBase + "general/put-signed-request-for-upload-to-s3",
    params
  );
}

export function putSignedUrlS3ForTask(params) {
  return Http.post(
    apiBase + "general/put-signed-request-for-upload-to-s3-task",
    params
  );
}

export function getEnterpriseDashboardData(params) {
  const queryParams = new URLSearchParams(params).toString();
  return Http.get(apiBase + "general/my-dashboard?" + queryParams);
}
